import React from 'react';
import { Typography } from '@mui/material';

import UserAlert from '../modals/userAlert';
import RenderIf from '../../renderIf';
import AdminReview from '../modals/adminReview';

const RecordChanges = (props) => {
    const { changes, markResolved } = props;

    const [reviewModalOpen, setReviewModalOpen] = React.useState(false);

    return (
        <>
            <RenderIf isTrue={!!changes && changes?.IsChangedOverride === false}>
                <UserAlert
                    type="error"
                    text={changes?.FlagMessage}
                    actions={
                        <>
                            <button
                                className="button-link"
                                onClick={() => setReviewModalOpen(true)}
                            >
                                <Typography>View differences</Typography>
                            </button>

                            <Typography sx={{ display: 'inline' }}>&nbsp;|&nbsp;</Typography>

                            <button
                                className="button-link"
                                onClick={() => {
                                    markResolved(changes.AppInstID);
                                }}
                            >
                                <Typography>Mark as resolved</Typography>
                            </button>
                        </>
                    }
                />
            </RenderIf>
            <AdminReview
                open={reviewModalOpen}
                closeModal={() => setReviewModalOpen(false)}
                content={changes}
            />
        </>
    );
};

export default RecordChanges;
